/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import { inferLocale } from "../common/Gettext";
import withData from "../withData";
import _RegisterMain from "./Tabs/RegisterMain";
import _SocialRegister from "./Tabs/SocialRegister";
import SocialPassword from "./Tabs/SocialPassword";
import LoginMain from "./Tabs/LoginMain";
import PasswordRestore from "./Tabs/PasswordRestore";
import SimpleSpinner from "../Spinners/SimpleSpinner";
import { withFetch } from "../common/fetch";
import BlockedCountry from "../BlockedCountry";

import type { State } from "../../redux/reducer";
import type { Dispatch } from "../../redux/action";

import PhoneErrorsLogger from "../PhoneErrorsLogger";

const RegisterMain = PhoneErrorsLogger(_RegisterMain);
const SocialRegister = PhoneErrorsLogger(_SocialRegister);

export const REGISTER_TAB_ID = "register";
export const LOGIN_TAB_ID = "login";
export const PASSWORD_RESTORE_TAB_ID = "password_restore";
export const SOCIAL_REGISTER_TAB_ID = "social_register";
export const SOCIAL_PASSWORD_TAB_ID = "social_password";
// export const PHONE_CONFIRM_TAB_ID = "phone_confirm";
// export const PHONE_CHANGE_TAB_ID = "phone_change";

type Screen =
  | "register"
  | "login"
  | "password_restore"
  | "social_register"
  | "social_password";
type Country = {
  currency: string,
};

type AuthProps = {
  dispatch: Dispatch,

  activeTab: ?Screen,
  showSocial: boolean,
  apiCountries: *,
  ref_user?: string,
  locale: string,
};

type AuthState = {
  screen: Screen,
  prevScreen: ?Screen,

  email: string,
  tel: string,
  password: string,
  agree: boolean,
  agreeDailyMail: boolean,
  country: ?Country,

  notification: ?string,
  notificationType: ?"restorePasswordWithEmail",
};

class Auth extends React.Component<AuthProps, AuthState> {
  state = {
    restricted: null,
    prevScreen: null,
    authTab: this.props.activeTab || LOGIN_TAB_ID,

    email: "",
    tel: "",
    password: "",
    agree: false,
    agreeDailyMail: true,
    country: this.props.apiCountries ? null : { currency: "THB" },

    notification: null,
    notificationType: null,
    socialError: null,
    restoreType: "email",
  };

  componentDidMount() {
    let chucknorris = "";
    if (window.location.search.indexOf("chucknorris=yes") > 0) {
      chucknorris = "?chuck-norris=yes";
    } else if (window.location.search.indexOf("chucknorris=no") > 0) {
      chucknorris = "?chuck-norris=no";
    }

    this.props
      .fetch(`/api/is-restricted${chucknorris}`, {
        unstable_dontInferResponse: true,
      })
      .then(({ restricted }) => {
        this.setState({ restricted });
      });

    this.props.fetch("/api/geo").then(({ country }) => {
      this.setState({ myCountry: country });
    });
  }

  setSocialError = (error) => {
    this.setState({
      socialError: error,
    });
  };

  handleInputChange = ({
    target,
  }: SyntheticEvent<HTMLInputElement> | Object) => {
    if (target instanceof HTMLInputElement && target.type === "checkbox") {
      const { name, checked } = target;
      this.setState({
        [name]: checked,
        notification: null,
      });
    } else {
      const { name, value } = target;
      this.setState({
        [name]: value,
        notification: null,
      });
    }
  };

  handlePhoneInputChange = ({
    target,
  }: SyntheticEvent<HTMLInputElement> | Object) => {
    const { name, value } = target;
    this.setState({
      [name]: /^\+?(\d+)?$/.test(value) ? value : this.state[name],
      notification: null,
    });
  };

  handleTabChange = (nextScreen: Screen, restoreType) => {
    if (restoreType) {
      this.setState({ restoreType });
    }

    if (typeof nextScreen === "string") {
      this.props.dispatch({
        type: "DISPLAY_AUTH_TAB",
        payload: nextScreen,
      });
    } else {
      const payload = this.state.prevScreen || LOGIN_TAB_ID;

      this.props.dispatch({
        type: "DISPLAY_AUTH_TAB",
        payload,
      });
    }
  };

  handleNotification = (notification: string, notificationType?: string) => {
    this.setState({ notification });

    if (notificationType === "restorePasswordWithEmail") {
      this.setState({ notificationType });
    } else {
      this.setState({ notificationType: null });
    }
  };

  render() {
    const {
      apiCountries = [],
      ref_user,
      profile,
      isAppLogin,
      isDarkPage,
    } = this.props;
    const {
      email,
      tel,
      password,
      agree,
      agreeDailyMail,
      country,
      notification,
      notificationType,
    } = this.state;

    const countryList = apiCountries.map((country) => {
      const { name, currency, flag, code } = country;
      return {
        value: name,
        currency,
        label: name,
        code: code === "XX" ? "world" : flag.alpha2code,
      };
    });

    if (this.state.restricted) {
      return (
        <BlockedCountry
          projectName={this.props.projectTitle}
          email={this.props.supportEmail}
          country={this.state.myCountry}
        />
      );
    } else if (this.state.restricted === null) {
      return <SimpleSpinner accent />;
    }

    // При соц реге, когда дозапрашиваем поля для регистрации,
    // во избежание unmount компонента, мы храним ошибку в стейте
    // и если ошибка есть, то мы по умолчанию делаем активной табу соц реги
    switch (
      this.state.socialError != null
        ? SOCIAL_REGISTER_TAB_ID
        : this.props.activeTab
    ) {
      case REGISTER_TAB_ID:
        return (
          <RegisterMain
            noRedirect={this.props.noRedirect}
            apiCountries={apiCountries}
            geo={this.props.geo}
            email={email}
            tel={tel}
            password={password}
            agree={agree}
            agreeDailyMail={agreeDailyMail}
            onInputChange={this.handleInputChange}
            onPhoneInputChange={this.handlePhoneInputChange}
            onLeave={this.handleTabChange}
            countryList={countryList}
            country={country}
            ref_user={ref_user}
            showSocial={this.props.showSocial}
            locale={this.props.locale}
            isIOS={this.props.isIOS}
            isDarkPage={isDarkPage}
            onDismissPopup={this.props.onDismissPopup}
          />
        );
      case LOGIN_TAB_ID:
        return (
          <LoginMain
            noRedirect={this.props.noRedirect}
            email={email}
            agree={agree}
            password={password}
            notification={notification}
            notificationType={notificationType}
            onInputChange={this.handleInputChange}
            onLeave={this.handleTabChange}
            country={country}
            showSocial={this.props.showSocial}
            locale={this.props.locale}
            ref_user={ref_user}
            isIOS={this.props.isIOS}
            isDarkPage={isDarkPage}
          />
        );
      case PASSWORD_RESTORE_TAB_ID:
        return (
          <PasswordRestore
            email={email}
            onInputChange={this.handleInputChange}
            onLeave={this.handleTabChange}
            onNotification={this.handleNotification}
            locale={this.props.locale}
            isDarkPage={isDarkPage}
            apiCountries={apiCountries}
            onPhoneInputChange={this.handlePhoneInputChange}
            tel={tel}
            geo={this.props.geo}
            restoreType={this.state.restoreType}
          />
        );
      case SOCIAL_REGISTER_TAB_ID:
        return (
          <SocialRegister
            email={email}
            tel={tel}
            agree={agree}
            agreeDailyMail={agreeDailyMail}
            apiCountries={apiCountries}
            onInputChange={this.handleInputChange}
            onPhoneInputChange={this.handlePhoneInputChange}
            onLeave={this.handleTabChange}
            countryList={countryList}
            country={country}
            profile={profile}
            isAppLogin={isAppLogin}
            geo={this.props.geo}
            isDarkPage={isDarkPage}
            onDismissPopup={this.props.onDismissPopup}
            setSocialError={this.setSocialError}
            socialError={this.state.socialError}
          />
        );
      case SOCIAL_PASSWORD_TAB_ID:
        return (
          <SocialPassword
            email={this.props.email}
            agree={agree}
            agreeDailyMail={agreeDailyMail}
            password={password}
            notification={notification}
            onInputChange={this.handleInputChange}
            onLeave={this.handleTabChange}
            country={country}
            showSocial={this.props.showSocial}
            locale={this.props.locale}
            query={this.props.query}
            location={this.props.location}
            history={this.props.history}
            isDarkPage={isDarkPage}
          />
        );
      default:
        return null;
    }
  }
}

function mapStateToProps(state: State) {
  return {
    projectTitle: state.serverData && state.serverData.projectTitle,
    supportEmail: state.serverData && state.serverData.supportEmail,
    isIOS: state.serverData.isIOS,
    geo: state.serverData.geo,
    locale: inferLocale(state),
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  // Это надо чтобы пользователь компонента мог перехватить экшен
  // и исполнить с ним что-нибудь своё
  return {
    dispatch: ownProps.dispatch || dispatch,
  };
}

export const RawAuth = connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth);

const requirements =
  process.env.REACT_APP_DEPLOY_TARGET !== "siamoption"
    ? { required: ["serverData", "apiCountries"], spinner: "simple" }
    : { required: ["serverData"] };

export default withData(requirements)(withFetch(RawAuth));



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js